import { Link } from 'gatsby';
import React from 'react';

import { checkIsInternalUrl, getInternalUrlPath } from '../utils/utils';

export interface SmartLinkProps extends React.HTMLAttributes<HTMLElement> {
  to: string;
  children: React.ReactNode;
  className?: string;
  openInNewTab?: boolean;
}

export default React.forwardRef<any, SmartLinkProps>(function SmartLink(
  { openInNewTab, className, children, to, ...restProps },
  ref,
): React.ReactElement {
  if (!openInNewTab && checkIsInternalUrl(to)) {
    return (
      <Link className={className} ref={ref} to={getInternalUrlPath(to)} {...restProps}>
        {children}
      </Link>
    );
  } else {
    return (
      <a
        className={className}
        ref={ref}
        href={to}
        target="_blank"
        rel="noopener noreferrer"
        {...restProps}
      >
        {children}
      </a>
    );
  }
});
